'use client';

import {
    AllysAgentsSection,
    AllysContactMapHero,
    AllysContactSection,
    AllysCTASection,
} from '@routeroyal/theme-allys';

type Props = {
  locale: 'en' | 'fr' | 'es';
  messages: Record<string, unknown>;
  basePath: string;
};

export function ContactContentAllys({ locale, messages, basePath }: Props) {
  // Helper to safely get nested string
  const get = (path: string, fallback = ''): string => {
    const keys = path.split('.');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let value: any = messages;
    for (const key of keys) {
      value = value?.[key];
      if (value === undefined) return fallback;
    }
    return typeof value === 'string' ? value : fallback;
  };

  return (
    <main className="min-h-screen">
      {/* Hero Section with Map */}
      <AllysContactMapHero
        messages={messages}
        locale={locale}
      />
      
      {/* Combined Contact Section - Contact Info + Form */}
      <AllysContactSection
        messages={messages}
        locale={locale}
      />
      
      {/* Agents Section - Same as home page */}
      <AllysAgentsSection
        messages={messages}
        locale={locale}
      />
      
      {/* CTA Section */}
      <AllysCTASection
        title={get('contact.cta.title', 'Ready to Find Your Perfect Property?')}
        description={get('contact.cta.description', 'Browse our exclusive listings or speak with our expert team')}
        primaryButton={{
          text: get('contact.cta.viewProperties', 'View Properties'),
          href: `${basePath}/properties`,
          variant: 'primary',
        }}
        secondaryButton={{
          text: get('contact.cta.scheduleViewing', 'Schedule a Viewing'),
          href: `${basePath}/contact`,
          variant: 'secondary',
        }}
        maskBackgroundImages={[
          'https://res.cloudinary.com/elementary-media/image/upload/v1762229962/photo-1706823128655-4034c2d89ecc_oalmng.webp',
          'https://res.cloudinary.com/elementary-media/image/upload/v1762230458/premium_photo-1664304455335-602b6811149a_k6m4sa.webp',
        ]}
        messages={messages}
        locale={locale}
      />
    </main>
  );
}
